var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgChevronLeftOutline = function SvgChevronLeftOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.414 12l7.293 7.293a1 1 0 01-1.414 1.414l-8-8a1 1 0 010-1.414l8-8a1 1 0 111.414 1.414L8.414 12z",
    fill: "#023F80"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNDE0MjEgMTJMMTUuNzA3MSAxOS4yOTI5QzE2LjA5NzYgMTkuNjgzNCAxNi4wOTc2IDIwLjMxNjYgMTUuNzA3MSAyMC43MDcxQzE1LjMxNjYgMjEuMDk3NiAxNC42ODM0IDIxLjA5NzYgMTQuMjkyOSAyMC43MDcxTDYuMjkyODkgMTIuNzA3MUM1LjkwMjM3IDEyLjMxNjYgNS45MDIzNyAxMS42ODM0IDYuMjkyODkgMTEuMjkyOUwxNC4yOTI5IDMuMjkyODlDMTQuNjgzNCAyLjkwMjM3IDE1LjMxNjYgMi45MDIzNyAxNS43MDcxIDMuMjkyODlDMTYuMDk3NiAzLjY4MzQyIDE2LjA5NzYgNC4zMTY1OCAxNS43MDcxIDQuNzA3MTFMOC40MTQyMSAxMloiIGZpbGw9IiMwMjNGODAiLz4KPC9zdmc+Cg==";
export { SvgChevronLeftOutline as ReactComponent };